//LOGIN
export const ADD_LOGIN = "ADD_LOGIN";
export const LOGIN_LOADING = "LOGIN_LOADING";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const REMOVE_LOGIN = "REMOVE_LOGIN";

//Users
export const USERS_SET_DATA = "USERS_SET_DATA";
export const USERS_LOADING = "USERS_LOADING";
export const USERS_DATA_FAIL = "USERS_DATA_FAIL";
export const FETCH_USERS = "FETCH_USERS";
export const USERS_FAILED = "USERS_FAILED";
export const FETCH_DUMMY_USERS = "FETCH_DUMMY_USERS";
export const DUMMY_USERS_LOADING = "DUMMY_USERS_LOADING";
export const DUMMY_USERS_FAILED = "DUMMY_USERS_FAILED";

//Dropdowns
export const SET_DROPDOWNS = "SET_DROPDOWNS";
export const DROPDOWNS_LOADING = "DROPDOWNS_LOADING";
export const DROPDOWNS_FAILED = "DROPDOWNS_FAILED";

//Dropdowns Details
export const FETCH_DROPDOWN_DETAILS = "FETCH_DROPDOWN_DETAILS";
export const DROPDOWN_DETAILS_LOADING = "DROPDOWN_DETAILS_LOADING";
export const DROPDOWN_DETAILS_FAILED = "DROPDOWN_DETAILS_FAILED";

//Banks
export const FETCH_BANKS = "FETCH_BANKS";
export const BANKS_LOADING = "BANKS_LOADING";
export const BANKS_FAILED = "BANKS_FAILED";

//Branches
export const FETCH_BRANCHES = "FETCH_BRANCHES";
export const BRANCHES_LOADING = "BRANCHES_LOADING";
export const BRANCHES_FAILED = "BRANCHES_FAILED";

//Negative Projects
export const FETCH_NEGATIVE_PROJECTS = "FETCH_NEGATIVE_PROJECTS";
export const NEGATIVE_PROJECTS_LOADING = "NEGATIVE_PROJECTS_LOADING";
export const NEGATIVE_PROJECTS_FAILED = "NEGATIVE_PROJECTS_FAILED";

//Open Market Property Sale Data
export const FETCH_EXTERNAL_DATA = "FETCH_EXTERNAL_DATA";
export const EXTERNAL_DATA_LOADING = "EXTERNAL_DATA_LOADING";
export const EXTERNAL_DATA_FAILED = "EXTERNAL_DATA_FAILED";

//DCR
export const FETCH_DCR_GOV_POLICY = "FETCH_DCR_GOV_POLICY";
export const DCR_GOV_POLICY_LOADING = "DCR_GOV_POLICY_LOADING";
export const DCR_GOV_POLICY_FAILED = "DCR_GOV_POLICY_FAILED";

//Real Estate
export const FETCH_REAL_ESTATE = "FETCH_REAL_ESTATE";
export const REAL_ESTATE_LOADING = "REAL_ESTATE_LOADING";
export const REAL_ESTATE_FAILED = "REAL_ESTATE_FAILED";

//States
export const SET_STATES = "SET_STATES";
export const STATES_LOADING = "STATES_LOADING";
export const STATES_FAILED = "STATES_FAILED";

//Tech Policy
export const FETCH_TECH_POLICY = "FETCH_TECH_POLICY";
export const TECH_POLICY_LOADING = "TECH_POLICY_LOADING";
export const TECH_POLICY_FAILED = "TECH_POLICY_FAILED";

//Tech Types
export const FETCH_TECH_TYPES = "FETCH_TECH_TYPES";
export const TECH_TYPES_LOADING = "TECH_TYPES_LOADING";
export const TECH_TYPES_FAILED = "TECH_TYPES_FAILED";

//Under Construction Projects
export const FETCH_UNDER_CONSTRUCT_PROJECTS = "FETCH_UNDER_CONSTRUCT_PROJECTS";
export const UNDER_CONSTRUCT_PROJECTS_LOADING =
  "UNDER_CONSTRUCT_PROJECTS_LOADING";
export const UNDER_CONSTRUCT_PROJECTS_FAILED =
  "UNDER_CONSTRUCT_PROJECTS_FAILED";

//Under Construction Projects
export const FETCH_AGREEMENTS = "FETCH_AGREEMENTS";
export const AGREEMENTS_LOADING = "AGREEMENTS_LOADING";
export const AGREEMENTS_FAILED = "AGREEMENTS_FAILED";

//*Properties
export const FETCH_PROPERTIES = "FETCH_PROPERTIES";
export const PROPERTIES_LOADING = "PROPERTIES_LOADING";
export const PROPERTIES_FAILED = "PROPERTIES_FAILED";
export const FETCH_SINGLE_PROPERTY = "FETCH_SINGLE_PROPERTY";

//*Completed Properties
export const COMPLETED_PROPERTIES_LOADING = "COMPLETED_PROPERTIES_LOADING";
export const COMPLETED_PROPERTIES_FAILED = "COMPLETED_PROPERTIES_FAILED";
export const FETCH_COMPLETED_PROPERTIES = "FETCH_COMPLETED_PROPERTIES";

//*View Work in progress property
export const FETCH_PROPERTY = "FETCH_PROPERTY";
export const PROPERTY_LOADING = "PROPERTY_LOADING";
export const PROPERTY_FAILED = "PROPERTY_FAILED";

//Projects
export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const FETCH_PROJECTS_ID = "FETCH_PROJECTS_ID";
export const PROJECTS_LOADING = "PROJECTS_LOADING";
export const PROJECTS_LOADING2 = "PROJECTS_LOADING2";
export const PROJECTS_LOADING_FALSE = "PROJECTS_LOADING_FALSE";
export const PROJECTS_FAILED = "PROJECTS_FAILED";
export const PROJECTS_LOADING_Id = "PROJECTS_LOADING_Id";
export const FETCH_PROJECTS_PHOTOGRAPH = "FETCH_PROJECTS_PHOTOGRAPH";

//Brokers
export const FETCH_BROKERS = "FETCH_BROKERS";
export const BROKERS_LOADING = "BROKERS_LOADING";
export const BROKERS_FAILED = "BROKERS_FAILED";
//map Brokers
export const FETCH_GOOGLEAPI = "FETCH_GOOGLEAPI";
export const GOOGLEAPI_LOADING = "GOOGLEAPI_LOADING";
export const GOOGLEAPI_FAILED = "GOOGLEAPI_FAILED";

//*Specifications
export const SPECIFICATIONS_LOADING = "SPECIFICATIONS_LOADING";
export const SPECIFICATIONS_LOADING_FALSE = "SPECIFICATIONS_LOADING_FALSE";
export const SPECIFICATIONS_FAILED = "SPECIFICATIONS_FAILED";

//*OCCUPATION
export const OCCUPATION_LOADING = "OCCUPATION_LOADING";
export const OCCUPATION_LOADING_FALSE = "OCCUPATION_LOADING_FALSE";
export const OCCUPATION_FAILED = "OCCUPATION_FAILED";

//*Unit detail
export const UNITDETAIL_LOADING = "UNITDETAIL_LOADING";
export const UNITDETAIL_LOADING_FALSE = "UNITDETAIL_LOADING_FALSE";
export const UNITDETAIL_FAILED = "UNITDETAIL_FAILED";

//*Project Stage
export const PROJECT_STAGE_LOADING = "PROJECT_STAGE_LOADING";
export const PROJECT_STAGE_LOADING_FALSE = "PROJECT_STAGE_LOADING_FALSE";
export const PROJECT_STAGE_FAILED = "PROJECT_STAGE_FAILED";

//*SURROUNDINGS
export const SURROUNDINGS_LOADING = "SURROUNDINGS_LOADING";
export const SURROUNDINGS_LOADING_FALSE = "SURROUNDINGS_LOADING_FALSE";
export const SURROUNDINGS_FAILED = "SURROUNDINGS_FAILED";

//*VALUATION
export const VALUATION_LOADING = "VALUATION_LOADING";
export const VALUATION_LOADING_FALSE = "VALUATION_LOADING_FALSE";
export const VALUATION_FAILED = "VALUATION_FAILED";

//*OBSERVATIONS
export const OBSERVATIONS_LOADING = "OBSERVATIONS_LOADING";
export const OBSERVATIONS_LOADING_FALSE = "OBSERVATIONS_LOADING_FALSE";
export const OBSERVATIONS_FAILED = "OBSERVATIONS_FAILED";

//*Google Api
export const GOOGLE_API_LOADING = "GOOGLE_API_LOADING";
export const GOOGLE_API_LOADING_FALSE = "GOOGLE_API_LOADING_FALSE";
export const GOOGLE_API_FAILED = "GOOGLE_API_FAILED";

//*Sale Rate
export const SALE_RATES_LOADING = "SALE_RATES_LOADING";
export const SALE_RATES_LOADING_FALSE = "SALE_RATES_LOADING_FALSE";
export const SALE_RATES_FAILED = "SALE_RATES_FAILED";

//*NDMCE
export const NDMCE_LOADING = "NDMCE_LOADING";
export const NDMCE_LOADING_FALSE = "NDMCE_LOADING_FALSE";
export const NDMCE_FAILED = "NDMCE_FAILED";

//*DEVIATION
export const DEVIATION_LOADING = "DEVIATION_LOADING";
export const DEVIATION_LOADING_FALSE = "DEVIATION_LOADING_FALSE";
export const DEVIATION_FAILED = "DEVIATION_FAILED";

//*COMPLIANCES
export const COMPLIANCES_LOADING = "COMPLIANCES_LOADING";
export const COMPLIANCES_LOADING_FALSE = "COMPLIANCES_LOADING_FALSE";
export const COMPLIANCES_FAILED = "COMPLIANCES_FAILED";

//*SPECIAL_REMARK
export const SPECIAL_REMARK_LOADING = "SPECIAL_REMARK_LOADING";
export const SPECIAL_REMARK_LOADING_FALSE = "SPECIAL_REMARK_LOADING_FALSE";
export const SPECIAL_REMARK_FAILED = "SPECIAL_REMARK_FAILED";

//*ANNEXURES
export const ANNEXURES_LOADING = "ANNEXURES_LOADING";
export const ANNEXURES_LOADING_FALSE = "ANNEXURES_LOADING_FALSE";
export const ANNEXURES_FAILED = "ANNEXURES_FAILED";

//*Deduce
export const FETCH_DEDUCE_ID = "FETCH_DEDUCE_ID";
export const DEDUCE_LOADING = "DEDUCE_LOADING";
export const DEDUCE_FAILED = "DEDUCE_FAILED";

//*MEASUREMENT
export const MEASUREMENT_LOADING = "MEASUREMENT_LOADING";
export const MEASUREMENT_LOADING_FALSE = "MEASUREMENT_LOADING_FALSE";
export const MEASUREMENT_FAILED = "MEASUREMENT_FAILED";

//*QUERIES
export const FETCH_QUERIES = "FETCH_QUERIES";
export const QUERIES_LOADING = "QUERIES_LOADING";
export const QUERIES_FAILED = "QUERIES_FAILED";

//*BILLS
export const FETCH_BILLS = "FETCH_BILLS";
export const BILLS_LOADING = "BILLS_LOADING";
export const BILLS_FAILED = "BILLS_FAILED";

//*Bank Verticals
export const SET_BANK_VERTICALS = "SET_BANK_VERTICALS";
export const BANK_VERTICALS_LOADING = "BANK_VERTICALS_LOADING";
export const BANK_VERTICALS_FAILED = "BANK_VERTICALS_FAILED";

//*Bank Products
export const FETCH_BANK_PRODUCTS = "FETCH_BANK_PRODUCTS";
export const BANK_PRODUCTS_LOADING = "BANK_PRODUCTS_LOADING";
export const BANK_PRODUCTS_FAILED = "BANK_PRODUCTS_FAILED";

//*site inspectors
export const FETCH_SITE_INSPECTORS = "FETCH_SITE_INSPECTORS";
export const SITE_INSPECTORS_LOADING = "SITE_INSPECTORS_LOADING";
export const SITE_INSPECTORS_FAILED = "SITE_INSPECTORS_FAILED";

//*Final Bills
export const FETCH_FINAL_BILLS = "FETCH_FINAL_BILLS";
export const FINAL_BILLS_LOADING = "FINAL_BILLS_LOADING";
export const FINAL_BILLS_FAILED = "FINAL_BILLS_FAILED";

//*AVM
export const FETCH_AVM = "FETCH_AVM";
export const AVM_LOADING = "AVM_LOADING";
export const AVM_FAILED = "AVM_FAILED";

//*Companies
export const FETCH_COMPANIES = "FETCH_COMPANIES";
export const COMPANIES_LOADING = "COMPANIES_LOADING";
export const COMPANIES_FAILED = "COMPANIES_FAILED";

//*Geo Tags
export const GEO_TAGS_LOADING = "GEO_TAGS_LOADING";
export const GEO_TAGS_FAILED = "GEO_TAGS_FAILED";
export const GEO_TAGS_LOADING_FALSE = "GEO_TAGS_LOADING_FALSE";

//*Stage Calculator
export const STAGE_CALCULATOR_LOADING = "STAGE_CALCULATOR_LOADING";
export const STAGE_CALCULATOR_FAILED = "STAGE_CALCULATOR_FAILED";
export const STAGE_CALCULATOR_LOADING_FALSE = "STAGE_CALCULATOR_LOADING_FALSE";

//*Home Improvements
export const HOME_IMPROVEMENTS_LOADING = "HOME_IMPROVEMENTS_LOADING";
export const HOME_IMPROVEMENTS_FAILED = "HOME_IMPROVEMENTS_FAILED";
export const HOME_IMPROVEMENTS_LOADING_FALSE =
  "HOME_IMPROVEMENTS_LOADING_FALSE";

//*Documents
export const DOCUMENTS_LOADING = "DOCUMENTS_LOADING";
export const DOCUMENTS_FAILED = "DOCUMENTS_FAILED";
export const DOCUMENTS_LOADING_FAILED = "DOCUMENTS_LOADING_FAILED";

//*Employee Location
export const SET_EMPLOYEE_LOCATION = "SET_EMPLOYEE_LOCATION";
export const EMPLOYEE_LOCATION_LOADING = "EMPLOYEE_LOCATION_LOADING";
export const EMPLOYEE_LOCATION_FAILED = "EMPLOYEE_LOCATION_FAILED";

//*Assign Property
export const FETCH_ASSIGN_PROPERTY_HISTORY = "FETCH_ASSIGN_PROPERTY_HISTORY";
export const ASSIGN_PROPERTY_LOADING = "ASSIGN_PROPERTY_LOADING";
export const ASSIGN_PROPERTY_FAILED = "ASSIGN_PROPERTY_FAILED";

//*Property Photos
export const PROPERTY_PHOTOS_LOADING = "PROPERTY_PHOTOS_LOADING";
export const PROPERTY_PHOTOS_FAILED = "PROPERTY_PHOTOS_FAILED";
export const PROPERTY_PHOTOS_LOADING_FALSE = "PROPERTY_PHOTOS_LOADING_FALSE";

//*Offline Properties MIS (Private Cases)
export const FETCH_OFFLINE_PROPERTIES = "FETCH_OFFLINE_PROPERTIES";
export const OFFLINE_PROPERTIES_LOADING = "OFFLINE_PROPERTIES_LOADING";
export const OFFLINE_PROPERTIES_FAILED = "OFFLINE_PROPERTIES_FAILED";

//*Case-Count
export const FETCH_CASE_COUNT = "FETCH_CASE_COUNT";
export const CASE_COUNT_LOADING = "CASE_COUNT_LOADING";
export const CASE_COUNT_FAILED = "CASE_COUNT_FAILED";

//*Pincodes
export const FETCH_PINCODES = "FETCH_PINCODES";
export const PINCODES_LOADING = "PINCODES_LOADING";
export const PINCODES_FAILED = "PINCODES_FAILED";

export const FETCH_PINCODE_PENDING_CASES = "FETCH_PINCODE_PENDING_CASES";
export const PINCODE_PENDING_CASES_LOADING = "PINCODE_PENDING_CASES_LOADING";
export const PINCODE_PENDING_CASES_FAILED = "PINCODE_PENDING_CASES_FAILED";

export const FETCH_BRANCH_PENDING_CASES = "FETCH_BRANCH_PENDING_CASES";
export const BRANCH_PENDING_CASES_LOADING = "BRANCH_PENDING_CASES_LOADING";
export const BRANCH_PENDING_CASES_FAILED = "BRANCH_PENDING_CASES_FAILED";

export const FETCH_BRANCH_INSPECTION_REPORT = "FETCH_BRANCH_INSPECTION_REPORT";
export const BRANCH_INSPECTION_REPORT_LOADING =
  "BRANCH_INSPECTION_REPORT_LOADING";
export const BRANCH_INSPECTION_REPORT_FAILED =
  "BRANCH_INSPECTION_REPORT_FAILED";

export const FETCH_BRANCH_RESVHEdule_FAIL = "FETCH_BRANCH_RESVHEdule_FAIL";
export const BRANCH_RESVHEdule_FAIL_LOADING = "BRANCH_RESVHEdule_FAIL_LOADING";
export const BRANCH_RESVHEdule_FAIL_FAILED = "BRANCH_RESVHEdule_FAIL_FAILED";

//*Bill Dashboard
export const FETCH_BILL_DASHBOARD = "FETCH_BILL_DASHBOARD";
export const BILL_DASHBOARD_LOADING = "BILL_DASHBOARD_LOADING";
export const BILL_DASHBOARD_FAILED = "BILL_DASHBOARD_FAILED";

//*Payment Master
export const FETCH_PAYMENT_MASTER = "FETCH_PAYMENT_MASTER";
export const PAYMENT_MASTER_LOADING = "PAYMENT_MASTER_LOADING";
export const PAYMENT_MASTER_FAILED = "PAYMENT_MASTER_FAILED";

// task management
export const FETCH_TASKS = "FETCH_TASKS";
export const TASKS_LOADING = "TASKS_LOADING";
export const TASKS_FAILED = "TASKS_FAILED";
// expenses management
export const FETCH_EXPENSES = "FETCH_EXPENSES";
export const EXPENSES_LOADING = "EXPENSES_LOADING";
export const EXPENSES_FAILED = "EXPENSES_FAILED";

// leave management
export const FETCH_LEAVES = "FETCH_LEAVES";
export const LEAVES_LOADING = "LEAVES_LOADING";
export const LEAVES_FAILED = "LEAVES_FAILED";
// iniciate Document
export const FETCH_DOCUMENT = "FETCH_DOCUMENT";
export const DOCUMENT_LOADING = "DOCUMENT_LOADING";
export const DOCUMENT_FAILED = "DOCUMENT_FAILED";

// export const ADD_ONE = "ADD_ONE";

const ADD_ONE = () => {
  return {
    type: "ADD_ONE",
  };
};
export default ADD_ONE;

// grpah
export const MONTLY_REPORT_DATA = "MONTLY_REPORT_DATA";
export const WEEKLY_REPORT_DATA = "WEEKLY_REPORT_DATA";
export const DAILY_PINCODE_GET_DATA = "DAILY_PINCODE_GET_DATA";
export const DAILYREPORTLOCATIONWISE = "DAILYREPORTLOCATIONWISE";
export const DAILYREPORTBANKWISE = "DAILYREPORTBANKWISE";
export const DAILY_REPORT_DAY_WISE = "DAILY_REPORT_DAY_WISE";
export const DAILY_REPORT_USER_WISE = "DAILY_REPORT_USER_WISE";
export const DAILY_REPORT_RELEASE = "DAILY_REPORT_RELEASE";
export const DAILY_REPORT_RELEASE_IN_TAT = "DAILY_REPORT_RELEASE_IN_TAT";
export const BRANCHWISEBILLAMOUNT = "BRANCHWISEBILLAMOUNT";
export const BILL_GRAPH_GET = "BILL_GRAPH_GET";
export const BILL_CONFIG_GET = "BILL_CONFIG_GET";
export const GETDASHBOARDCOUNT = "GETDASHBOARDCOUNT";
export const GETBANKSTATSTABLEDASHBOARD = "GETBANKSTATSTABLEDASHBOARD";
export const GETBRANCHBANKWISEDASHBOARD = "GETBRANCHBANKWISEDASHBOARD";
export const GETBANKWISEREVENUE = "GETBANKWISEREVENUE";
export const GETEMPLOYEEWISESTATSTABLE = "GETEMPLOYEEWISESTATSTABLE";
export const GETDAILYREPORTNOTRELEASE = "GETDAILYREPORTNOTRELEASE";
export const GETHOURLYPROPS = "GETHOURLYPROPS";
export const GETBANKWISEOVERALLSTATS = "GETBANKWISEOVERALLSTATS";
export const BILLCOUNT = "BILLCOUNT";
export const YIELD_GET = "YIELD_GET";
export const RENT_GET = "RENT_GET";
export const PROJECT_RATE = "PROJECT_RATE";

// task management
export const FETCH_SPECIAL_REMARKS = "FETCH_SPECIAL_REMARKS";
export const SPECIAL_REMARKS_LOADING = "SPECIAL_REMARKS_LOADING";
export const SPECIAL_REMARKS_FAILED = "SPECIAL_REMARKS_FAILED";
// Ready Reckoner
export const FETCH_READYRECKNERS = "FETCH_READYRECKNERS";
export const READYRECKNERS_LOADING = "READYRECKNERS_LOADING";
export const READYRECKNERS_FAILED = "READYRECKNERS_FAILED";
// MailType
export const FETCH_MAILTYPE_MASTER = "FETCH_MAILTYPE_MASTER";
export const MAILTYPE_MASTER_LOADING = "MAILTYPE_MASTER_LOADING";
export const MAILTYPE_MASTER_FAILED = "MAILTYPE_MASTER_FAILED";
// MailTime
export const FETCH_MAILTIME_MASTER = "FETCH_MAILTIME_MASTER";
export const MAILTIME_MASTER_LOADING = "MAILTIME_MASTER_LOADING";
export const MAILTIME_MASTER_FAILED = "MAILTIME_MASTER_FAILED";

//*Branch Master
export const FETCH_BRANCH_MASTER = "FETCH_BRANCH_MASTER";
export const BRANCH_MASTER_LOADING = "BRANCH_MASTER_LOADING";
export const BRANCH_MASTER_FAILED = "BRANCH_MASTER_FAILED";

//*Company Document
export const COMPANY_DOCUMENT_FAILED = "COMPANY_DOCUMENT_FAILED";
export const COMPANY_DOCUMENT_LOADING = "COMPANY_DOCUMENT_LOADING";
export const FETCH_COMPANY_DOCUMENT = "FETCH_COMPANY_DOCUMENT";

// reset password
export const FORGOT_PASSWORD_SET_DATA = "FORGOT_PASSWORD_SET_DATA";
export const FORGOT_PASSWORD_FAIL_DATA = "FORGOT_PASSWORD_FAIL_DATA";
export const FORGOT_PASSWORD_LOADING = "FORGOT_PASSWORD_LOADING";
export const UPDATE_PASSWORD_LOADING = "UPDATE_PASSWORD_LOADING";
export const UPDATE_PASSWORD_FAIL_DATA = "UPDATE_PASSWORD_FAIL_DATA";
export const UPDATE_PASSWORD_SET_DATA = "UPDATE_PASSWORD_SET_DATA";

//*Properties Location
export const SET_PROPERTIES_LOCATION = "SET_PROPERTIES_LOCATION";
export const PROPERTIES_LOCATION_LOADING = "PROPERTIES_LOCATION_LOADING";
export const PROPERTIES_LOCATION_FAILED = "PROPERTIES_LOCATION_FAILED";

// complincecs
export const COMPLIANCESMASTER_LOADING = "COMPLIANCESMASTER_LOADING";
export const COMPLIANCESMASTER_FAILED = "COMPLIANCESMASTER_FAILED";
export const COMPLIANCESMASTER_LOADING_FALSE =
  "COMPLIANCESMASTER_LOADING_FALSE";
export const FETCH_COMPLIANCEMASTER = "FETCH_COMPLIANCEMASTER";

// matrix management
export const FETCH_MATRIXS = "FETCH_MATRIXS";
export const MATRIXS_LOADING = "MATRIXS_LOADING";
export const MATRIXS_FAILED = "MATRIXS_FAILED";

//*comparable
export const FETCH_PROPERTY1 = "FETCH_PROPERTY1";
export const PROPERTY_LOADING1 = "PROPERTY_LOADING1";
export const PROPERTY_FAILED1 = "PROPERTY_FAILED1";
export const FETCH_PROPERTY2 = "FETCH_PROPERTY2";
export const PROPERTY_LOADING2 = "PROPERTY_LOADING2";
export const PROPERTY_FAILED2 = "PROPERTY_FAILED2";
export const FETCH_PROPERTY3 = "FETCH_PROPERTY3";
export const PROPERTY_LOADING3 = "PROPERTY_LOADING3";
export const PROPERTY_FAILED3 = "PROPERTY_FAILED3";

// offerletters management
export const FETCH_OFFERLETTERS = "FETCH_OFFERLETTERS";
export const OFFERLETTERS_LOADING = "OFFERLETTERS_LOADING";
export const OFFERLETTERS_FAILED = "OFFERLETTERS_FAILED";
// relievingletters management
export const FETCH_RELIEVINGLETTERS = "FETCH_RELIEVINGLETTERS";
export const RELIEVINGLETTERS_LOADING = "RELIEVINGLETTERS_LOADING";
export const RELIEVINGLETTERS_FAILED = "RELIEVINGLETTERS_FAILED";
// asets management
export const FETCH_ASSETS = "FETCH_ASSETS";
export const ASSETS_LOADING = "ASSETS_LOADING";
export const ASSETS_FAILED = "ASSETS_FAILED";

//*TICKETS
export const FETCH_TICKETS = "FETCH_TICKETS";
export const TICKETS_LOADING = "TICKETS_LOADING";
export const TICKETS_FAILED = "TICKETS_FAILED";

//*LEARNINGS
export const FETCH_LEARNINGS = "FETCH_LEARNINGS";
export const LEARNINGS_LOADING = "LEARNINGS_LOADING";
export const LEARNINGS_FAILED = "LEARNINGS_FAILED";

//*PROJECTDOCUMENT
export const FETCH_PROJECTDOCUMENT = "FETCH_PROJECTDOCUMENT";
export const PROJECTDOCUMENT_LOADING = "PROJECTDOCUMENT_LOADING";
export const PROJECTDOCUMENT_FAILED = "PROJECTDOCUMENT_FAILED";

export const FETCH_MANUAL_SENDMAIL = "FETCH_MANUAL_SENDMAIL";
export const MANUAL_SENDMAIL_LOADING = "MANUAL_SENDMAIL_LOADING";
export const MANUAL_SENDMAIL_FAILED = "MANUAL_SENDMAIL_FAILED";

// DocumentMaster

export const FETCH_DOCUMENTMASTERS = "FETCH_DOCUMENTMASTERS";
export const DOCUMENTMASTERS_LOADING = "DOCUMENTMASTERS_LOADING";
export const DOCUMENTMASTERS_FAILED = "DOCUMENTMASTERS_FAILED";

// NpaMaster

export const FETCH_NPAMASTERS = "FETCH_NPAMASTERS";
export const NPAMASTERS_LOADING = "NPAMASTERS_LOADING";
export const NPAMASTERS_FAILED = "NPAMASTERS_FAILED";

// DocumentMaster

export const FETCH_PROJECTAPFREPORT = "FETCH_PROJECTAPFREPORT";
export const FETCH_PROJECTAPFREPORTID = "FETCH_PROJECTAPFREPORTID";
export const PROJECTAPFREPORT_LOADING = "PROJECTAPFREPORT_LOADING";
export const PROJECTAPFREPORT_FAILED = "PROJECTAPFREPORT_FAILED";

// register
export const REGISTER_SET_DATA = "REGISTER_SET_DATA";

// FeedbackQuestion

export const FETCH_FEEDBACKQUESTIONS = "FETCH_FEEDBACKQUESTIONS";
export const FEEDBACKQUESTIONS_LOADING = "FEEDBACKQUESTIONS_LOADING";
export const FEEDBACKQUESTIONS_FAILED = "FEEDBACKQUESTIONS_FAILED";
// projectform stage

export const FETCH_PROJECTSTAGE = "FETCH_PROJECTSTAGE";
export const PROJECTSTAGE_LOADING = "PROJECTSTAGE_LOADING";
export const PROJECTSTAGE_FAILED = "PROJECTSTAGE_FAILED";

// NdmaParameter

export const FETCH_NDMAPARAMETERS = "FETCH_NDMAPARAMETERS";
export const NDMAPARAMETERS_LOADING = "NDMAPARAMETERS_LOADING";
export const NDMAPARAMETERS_FAILED = "NDMAPARAMETERS_FAILED";

// FeedbackAnswer

export const FETCH_FEEDBACKANSWERS = "FETCH_FEEDBACKANSWERS";
export const FEEDBACKANSWERS_LOADING = "FEEDBACKANSWERS_LOADING";
export const FEEDBACKANSWERS_FAILED = "FEEDBACKANSWERS_FAILED";

// Note

export const FETCH_NOTES = "FETCH_NOTES";
export const NOTES_LOADING = "NOTES_LOADING";
export const NOTES_FAILED = "NOTES_FAILED";

// reset bankerpassword
export const FORGOT_BANKERPASSWORD_SET_DATA = "FORGOT_BANKERPASSWORD_SET_DATA";
export const FORGOT_BANKERPASSWORD_FAIL_DATA =
  "FORGOT_BANKERPASSWORD_FAIL_DATA";
export const FORGOT_BANKERPASSWORD_LOADING = "FORGOT_BANKERPASSWORD_LOADING";
export const UPDATE_BANKERPASSWORD_LOADING = "UPDATE_BANKERPASSWORD_LOADING";
export const UPDATE_BANKERPASSWORD_FAIL_DATA =
  "UPDATE_BANKERPASSWORD_FAIL_DATA";
export const UPDATE_BANKERPASSWORD_SET_DATA = "UPDATE_BANKERPASSWORD_SET_DATA";

//docPickupRequest
export const docPickupRequest_FAILED = "docPickupRequest_FAILED";
export const docPickupRequest_LOADING = "docPickupRequest_LOADING";
export const FETCH_docPickupRequest = "FETCH_docPickupRequest";

//docPickupRequest
export const BRANCH_USERS_LOADING = "BRANCH_USERS_LOADING";
export const FETCH_BRANCH_USERS = "FETCH_BRANCH_USERS";
export const BRANCH_USERS_FAILED = "BRANCH_USERS_FAILED";

//stageupdationReport
export const FETCH_PROJECT_STAGE_REPORTS = "FETCH_PROJECT_STAGE_REPORTS";
export const PROJECT_STAGE_REPORTS_LOADING = "PROJECT_STAGE_REPORTS_LOADING";
export const PROJECT_STAGE_REPORTS_FAILED = "PROJECT_STAGE_REPORTS_FAILED";

// Inventory Valuation Report
export const INVENTORY_VALUATION_LOADING = "INVENTORY_VALUATION_LOADING";
export const INVENTORY_VALUATION_FAILED = "INVENTORY_VALUATION_FAILED";
export const FETCH_INVENTORY_VALUATION_REPORTS =
  "FETCH_INVENTORY_VALUATION_REPORTS";
export const FETCH_SINGLE_INVENTORY_VALUATION_REPORT =
  "FETCH_SINGLE_INVENTORY_VALUATION_REPORT";

//states
export const FETCH_STATES = "FETCH_STATES";
export const STATE_LOADING = "STATES_LOADING";
export const STATE_FAILED = "STATES_FAILED";
export const FETCH_DISTRICTS = "FETCH_DISTRICTS";
export const DISTRICTS_LOADING = "DISTRICTS_LOADING";
export const DISTRICTS_FAILED = "DISTRICTS_FAILED";
export const FETCH_TALUKAS = "FETCH_TALUKAS";
export const TALUKAS_LOADING = "TALUKAS_LOADING";
export const TALUKAS_FAILED = "TALUKAS_FAILED";
export const FETCH_CITY = "FETCH_CITY";
export const CITY_LOADING = "CITY_LOADING";
export const CITY_FAILED = "CITY_FAILED";
export const FETCH_AREAS = "FETCH_AREAS";
export const AREAS_LOADING = "AREAS_LOADING";
export const AREAS_FAILED = "AREAS_FAILED";
export const FETCH_AREA_PINCODES = "FETCH_AREA_PINCODES";
export const AREA_PINCODES_LOADING = "AREA_PINCODES_LOADING";
export const AREA_PINCODES_FAILED = "AREA_PINCODES_FAILED";

// src/Redux/Types/ActionTypes.js
export const FETCH_BRANCH_CASE_COUNT = "FETCH_BRANCH_CASE_COUNT";
export const BRANCH_CASE_COUNT_LOADING = "BRANCH_CASE_COUNT_LOADING";
export const BRANCH_CASE_COUNT_FAILED = "BRANCH_CASE_COUNT_FAILED";

//Dashboard

//RatingStatistics
export const EMPLOYEE_ANALYTIC_LOADER_START= "EMPLOYEE_ANALYTIC_LOADER_START";
export const EMPLOYEE_ANALYTIC= "EMPLOYEE_ANALYTIC";
export const EMPLOYEE_ANALYTIC_LOADER_STOP= "EMPLOYEE_ANALYTIC_LOADER_STOP";

//Backoffice
export const ADMIN_CASE_COUNT_LOADER_START= "ADMIN_CASE_COUNT_LOADER_START";
export const ADMIN_CASE_COUNT= "ADMIN_CASE_COUNT";
export const ADMIN_CASE_COUNT_LOADER_STOP= "ADMIN_CASE_COUNT_LOADER_STOP";

//billdashboardMain
export const FINAL_BILLS_FINANCEANALYTICS_LOADER_START= "FINAL_BILLS_FINANCEANALYTICS_LOADER_START";
export const FINAL_BILLS_FINANCEANALYTICS= "FINAL_BILLS_FINANCEANALYTICS";
export const FINAL_BILLS_FINANCEANALYTICS_LOADER_STOP= "FINAL_BILLS_FINANCEANALYTICS_LOADER_STOP";

//billstatistics
export const FINAL_BILLS_ANALYTICS_LOADER_START= "FINAL_BILLS_ANALYTICS_LOADER_START";
export const FINAL_BILLS_ANALYTICS= "FINAL_BILLS_ANALYTICS";
export const FINAL_BILLS_ANALYTICS_LOADER_STOP= "FINAL_BILLS_ANALYTICS_LOADER_STOP";

//Dashboard
export const DASHBOARD_LOADER_START= "DASHBOARD_LOADER_START";
export const DASHBOARD= "DASHBOARD";
export const DASHBOARD_LOADER_STOP= "DASHBOARD_LOADER_STOP";

//Dashboard2
export const DASHBOARD_TWO_LOADER_START= "DASHBOARD_TWO_LOADER_START";
export const DASHBOARD_TWO= "DASHBOARD_TWO";
export const DASHBOARD_TWO_LOADER_STOP= "DASHBOARD_TWO_LOADER_STOP";

//ExpenseStatistics
export const EXPENSES_LOADER_START= "EXPENSES_LOADER_START";
export const EXPENSES= "EXPENSES";
export const EXPENSES_LOADER_STOP= "EXPENSES_LOADER_STOP";

//PendingDashboard
export const PENDING_LOADER_START= "PENDING_LOADER_START";
export const PENDING= "PENDING";
export const PENDING_LOADER_STOP= "PENDING_LOADER_STOP";

//SalesDashboard
export const SALES_LOADER_START= "SALES_LOADER_START";
export const SALES= "SALES";
export const SALES_LOADER_STOP= "SALES_LOADER_STOP";

//SiteDashboard
export const SITE_DASHBOARD_LOADER_START= "SITE_DASHBOARD_LOADER_START";
export const SITE_DASHBOARD= "SITE_DASHBOARD";
export const SITE_DASHBOARD_LOADER_STOP= "SITE_DASHBOARD_LOADER_STOP";

//TaskDashboard
export const TASK_ANALYTICS_LOADER_START= "TASK_ANALYTICS_LOADER_START";
export const TASK_ANALYTICS= "TASK_ANALYTICS";
export const TASK_ANALYTICS_LOADER_STOP= "TASK_ANALYTICS_LOADER_STOP";

export const STAGEREVIEW_LOADING = "STAGEREVIEW_LOADING";
export const STAGEREVIEW_SUCCESS = "STAGEREVIEW_SUCCESS";
export const STAGEREVIEW_ERROR = "STAGEREVIEW_ERROR";

// src/Redux/Types/StageCalculatorTypes.js
export const FETCH_STAGE_CALCULATOR_REQUEST = "FETCH_STAGE_CALCULATOR_REQUEST";
export const FETCH_STAGE_CALCULATOR_SUCCESS = "FETCH_STAGE_CALCULATOR_SUCCESS";
export const FETCH_STAGE_CALCULATOR_FAILURE = "FETCH_STAGE_CALCULATOR_FAILURE";

export const UPDATE_STAGE_CALCULATOR_REQUEST = "UPDATE_STAGE_CALCULATOR_REQUEST";
export const UPDATE_STAGE_CALCULATOR_SUCCESS = "UPDATE_STAGE_CALCULATOR_SUCCESS";
export const UPDATE_STAGE_CALCULATOR_FAILURE = "UPDATE_STAGE_CALCULATOR_FAILURE";

// src/Redux/Types/ActionTypes.js

export const CREATE_STAGE_CALCULATOR_REQUEST = "CREATE_STAGE_CALCULATOR_REQUEST";
export const CREATE_STAGE_CALCULATOR_SUCCESS = "CREATE_STAGE_CALCULATOR_SUCCESS";
export const CREATE_STAGE_CALCULATOR_FAILURE = "CREATE_STAGE_CALCULATOR_FAILURE";